export default function extractNumber(valor) {
  return valor.replace(/[^0-9]/g, '');
}
